import { axiosInstance } from "@src/shared/api";
import { LIGIN_API_URL } from "../constants";

interface IsUserExistRequestProps {
  email: string;
}

interface IsUserExistResponse {
  exists: string;
}

export const isUserExist = (data: IsUserExistRequestProps) =>
  axiosInstance.post<IsUserExistResponse>(LIGIN_API_URL.isUserExist(), data);
